import { clamp } from "@common/helpers/collections";

export const SLICE_TOOLTIP_GAP_PX = 8;

interface PlotSpan {
    start: number;
    end: number;
}

interface PlaceSliceTooltipParams {
    bucketIndex: number;
    bucketCount: number;
    plotWidth: number;
    tooltipWidth: number;
    /** The part of the plot in view, in px from its left; defaults to all of it. */
    visible?: PlotSpan;
}

/**
 * Right of its bar, or left when that runs past the bars in view. When
 * neither fits, the card stays inside them.
 */
export function placeSliceTooltip({
    bucketIndex,
    bucketCount,
    plotWidth,
    tooltipWidth,
    visible = { start: 0, end: plotWidth },
}: PlaceSliceTooltipParams): number {
    const barStart = (bucketIndex / bucketCount) * plotWidth;
    const barEnd = ((bucketIndex + 1) / bucketCount) * plotWidth;
    const right = barEnd + SLICE_TOOLTIP_GAP_PX;
    const left = barStart - SLICE_TOOLTIP_GAP_PX - tooltipWidth;
    const fits = (x: number) =>
        x >= visible.start && x + tooltipWidth <= visible.end;
    if (fits(right) || fits(left)) {
        return fits(right) ? right : left;
    }
    return clamp(
        left,
        visible.start,
        Math.max(visible.end - tooltipWidth, visible.start),
    );
}
